import { BrowserRouter } from 'react-router-dom'
import { UserProvider } from '@mfox/shared/contexts/UserProvider'
import { AppRoutes } from './app/routes'

// XP notices sit in the page's flow: the app frame and the test runner each place their own ToastHost.
function App() {
  return (
    <BrowserRouter>
      <UserProvider>
        <AppRoutes />
      </UserProvider>
    </BrowserRouter>
  )
}

export default App
